// 接口定义
import base from './base'

import login from './modules/login'
import dashboard from './modules/dashboard'
import commodity from './modules/commodity'
import recharge from './modules/recharge'
import order from './modules/order'
import supplier from './modules/supplier'
import agent from './modules/agent'
import system from './modules/system'

export default {
  ...base,
  login,
  dashboard,
  commodity,
  recharge,
  order,
  supplier,
  agent,
  system
}
